// @ts-nocheck
import { Grid2 as Grid, TextField } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { User } from "../types"
import { transformErrorForForm } from "../utils/utils"
import { FormInDialogProps } from "./DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"

const schema = yup.object().shape({
  old_password: yup.string().required(),
  password: yup.string().required(),
  confirm_password: yup
    .string()
    .required()
    .oneOf([yup.ref("password")], "Le password non corrispondono")
})

export default function ChangePasswordForm({ item, save, ref }: FormInDialogProps<User>) {
  const initialValues = useMemo(() => {
    return (
      item ?? {
        old_password: "",
        password: "",
        confirm_password: "",
      }
    )
  }, [item])

  const { t } = useTranslation()

  return (
    <Formik initialValues={initialValues} validationSchema={schema} enableReinitialize onSubmit={save}>
      {({ handleSubmit, values, setFieldValue, errors, submitCount }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="old_password"
                  type="password"
                  label={t("profilo.vecchia_password")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
                <Field
                  component={FormikTextField}
                  name="password"
                  type="password"
                  label={t("profilo.nuova_password")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
                <Field
                  component={FormikTextField}
                  name="confirm_password"
                  type="password"
                  label={t("profilo.conferma_password")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
